var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("h3", { staticStyle: { margin: "1rem", "font-size": "1.4rem" } }, [
        _vm._v("便利店销售报表汇总")
      ]),
      _c(
        "div",
        { staticClass: "block" },
        [
          _c("span", { staticClass: "demonstration" }, [_vm._v("选择日期")]),
          _c("el-date-picker", {
            staticStyle: { width: "20rem !important" },
            attrs: {
              editable: false,
              size: "small",
              type: "daterange",
              "range-separator": "~",
              "start-placeholder": "开始日期",
              "end-placeholder": "结束日期",
              "value-format": "timestamp",
              "picker-options": _vm.pickerOptionsStart
            },
            model: {
              value: _vm.datePickerValue,
              callback: function($$v) {
                _vm.datePickerValue = $$v
              },
              expression: "datePickerValue"
            }
          }),
          _c(
            "el-button",
            {
              attrs: {
                loading: _vm.downloadLoading,
                size: "small",
                type: "primary"
              },
              on: { click: _vm.loadData }
            },
            [_vm._v("查询")]
          ),
          _vm.userInfo.authorityId === "888" ||
          _vm.userInfo.authorityId === "9994" ||
          _vm.userInfo.authorityId === "9990"
            ? _c(
                "el-button",
                {
                  attrs: {
                    loading: _vm.downloadLoading,
                    size: "small",
                    type: "warning",
                    icon: "el-icon-document"
                  },
                  on: {
                    click: function($event) {
                      return _vm.exportExcel(
                        _vm.excelSheets,
                        "便利店月销售汇总"
                      )
                    }
                  }
                },
                [_vm._v(" 下载报表 ")]
              )
            : _vm._e(),
          _c("h4", { staticStyle: { color: "orangered" } }, [
            _vm._v("*系统迁移原因，部分油站2022年4月前的数据在旧收银系统")
          ])
        ],
        1
      ),
      _c("br"),
      _c(
        "el-table",
        {
          ref: "shopMonthTotalData",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.shopMonthTotalData,
            id: "shopMonthTotalData",
            "show-summary": "",
            "sum-text": "合计",
            "highlight-current-row": "",
            border: "",
            height: "640"
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "站点",
              width: "200px",
              align: "center",
              prop: "station.stationName"
            }
          }),
          _c("el-table-column", {
            attrs: {
              label: "统计天数",
              width: "100px",
              align: "center",
              prop: "dailyDate"
            }
          }),
          _c("el-table-column", {
            attrs: {
              label: "应收",
              width: "100px",
              align: "center",
              prop: "payablesAmount"
            }
          }),
          _c("el-table-column", {
            attrs: {
              label: "券优惠",
              width: "100px",
              align: "center",
              prop: "couponDiscount"
            }
          }),
          _c("el-table-column", {
            attrs: {
              label: "积分优惠",
              width: "100px",
              align: "center",
              prop: "pointDiscount"
            }
          }),
          _c("el-table-column", {
            attrs: {
              label: "促销优惠",
              width: "100px",
              align: "center",
              prop: "sellerDiscount"
            }
          }),
          _c("el-table-column", {
            attrs: {
              label: "实收",
              width: "100px",
              align: "center",
              prop: "paymentsAmount"
            }
          }),
          _c("el-table-column", {
            attrs: {
              label: "成本",
              width: "100px",
              align: "center",
              prop: "goodsCost"
            }
          }),
          _c("el-table-column", {
            attrs: {
              label: "利润",
              width: "100px",
              align: "center",
              prop: "goodsProfit"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }